// extracted by mini-css-extract-plugin
export default {"base":"LastPage_base__90Y0l","text":"LastPage_text__M483d","footer":"LastPage_footer__dGY0V","logo":"LastPage_logo__xMBxf"};